module.exports = __webpack_public_path__ + "img/icon_guardianship.5fbc9728.png";